import React from "react";
import bannerImg from "../../assets/images/wev-d.png";
import "../../styles/Webdevelopment.css";
import { Link } from "react-router-dom";

function UIbanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          <h1>Web Design Services for Modern Business Growth</h1>
          <p>
            In nowadays’s digital global, companies need more than only a
            website. They need a powerful on line platform that attracts
            clients, builds believe, and increases conversions. Our expert{" "}
            <b>web design services</b> are designed to help
            businesses create visually attractive, rapid-loading, and search
            engine optimization-friendly web sites that deliver actual
            commercial enterprise effects.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg} alt="Web Development Solutions" />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Web Design Services</span>
      </div>
    </div>
  );
}

export default UIbanner;
